/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type HTMLAttributes, createContext, forwardRef } from 'react';
import type { SlotProps } from 'react-aria-components';
import { type ContextValue, useContextProps } from 'react-aria-components';

interface ViewProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style' | 'className' | 'slot'>, SlotProps {
  style?: stylex.StyleXStyles;
}

const ViewContext = createContext<ContextValue<ViewProps, HTMLDivElement>>({});

const View = forwardRef((props: ViewProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, ViewContext);

  const { style, children, slot, ...attributes } = props;

  return (
    <div
      ref={ref}
      slot={slot || undefined}
      {...stylex.props(style)}
      {...attributes}>
      {children}
    </div>
  );
});

export { View, ViewContext, type ViewProps };
